<template>
  <div class="map-pc">
    <div class="amap-wrapper" style="width:66.66666%; height: 100vh">
      <el-amap
        ref="map"
        :amap-manager="amapManager"
        :center="center"
        :zoom="zoom"
        :events="events"
        :plugin="plugin"
        class="amap-box"
      ></el-amap>
    </div>
    <div class="arrive_list" style="width:33.33333%; height: 100vh">
      <div class="head">
        <img src="../../assets/arrive-head.png" />
      </div>
      <div class="body">
        <div
          v-for="(group, index) in l_time_list"
          :key="index"
          class="item"
          :class="`${index != 0 && index % 2 == 0 ? 'even' : ''} ${index == 0 ? 'first' : ''}`"
        >
          <div v-if="index == 0" class="img"></div>
          <div class="info">
            <div class="g-name">{{ group.groupname }}</div>
            <div class="g-num">{{ group.ename }}</div>
          </div>
          <div class="l-time">{{ group.l_time | time }}</div>
        </div>
      </div>
      <div class="footer">*以上信息仅供参考，以现场实际信息为准</div>
    </div>
  </div>
</template>

<script>
import map_icon from '../../assets/map-icon.png'
import { getMapData } from '@/libs/api.js'

import { line, linex, cp0, cp1, cp2 } from './line'

import { AMapManager } from 'vue-amap'
let amapManager = new AMapManager()

let loading = false

const mark_a = process.env.BASE_URL + 'map_icon/mark_a.png'
const mark_b = process.env.BASE_URL + 'map_icon/mark_b.png'

export default {
  filters: {
    time(val) {
      if (!val) return '--分--秒'
      val = new Date(val)
      let h = val.getHours()
      let m = val.getMinutes()
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      return h + ':' + m
    },
  },
  mounted() {
    let self = this
  },
  data() {
    let self = this
    return {
      json: '0.0',
      l_time_list: [],
      p_list: [],
      list: [],
      amapManager,
      center: [121.457996,31.178279],
      zoom: 12,
      events: {
        init: (o) => {
          self.amapManager = o

          var polyline = new AMap.Polyline({
            map: o,
            path: line,
            showDir: true,
            strokeColor: '#28F', //线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 8, //线宽
            // strokeStyle: "solid"  //线样式
          })

          o.setFitView()
          // o.setMapStyle("amap://styles/db0aae9736c55cc8d4379cedce535e0b");

          console.log(o.getMapStyle())

          self.get_map_data()
          setInterval(() => {
            if (loading) {
              return
            }
            self.get_map_data()
          }, 5000)
        },
        // 地图点击事件
        click: (e) => {},
      },
      plugin: [],
    }
  },
  methods: {
    create_marker(scorename, position) {
      const self = this
      let icon_url = mark_a
      let class_name = 'mark_a'
      if (scorename.slice(0, 1) == 'B') {
        icon_url = mark_b
        class_name = 'mark_b'
      }

      return new AMap.Marker({
        icon: icon_url,
        map: self.amapManager,
        position: position || cp0,
        autoRotation: true,
        angle: -90,
        label: {
          content: `<div class="${class_name}">${scorename}</div>`,
          offset: new AMap.Pixel(-8, -24),
          direction: 'center',
        },
      })
    },
    get_map_data() {
      loading = true
      getMapData(this.$route.query)
        .then((r) => {
          let self = this
          if (r.status == 200) {
            this.list = r.data.list
            let p_list = {}
            this.l_time_list = []
            r.data.list.forEach((row, index) => {
              // 即将抵达列表数据
              if (!(row.cpname == 'cp0' && (row.chipid2 || row.statenumber == 1))) {
                let l_time
                let i = null
                switch (row.cpname) {
                  case 'cp0':
                    if (row.lastcpname == 'cp1') {
                      l_time = 1.9 / row.speed
                    } else {
                      l_time = 2.1 / row.speed
                    }
                    break
                  case 'cp1':
                    l_time = 1.05 / row.speed
                    break
                  case 'cp2':
                    l_time = 1.04 / row.speed
                    break
                }

                l_time = l_time * 3600000 + row.time * 1

                this.l_time_list.push({
                  ename: row.ename,
                  groupname: row.groupname,
                  unit: row.unit,
                  l_time,
                })
              }

              let i = row.cpname.slice(-1) * 1 + 1
              if (row.cpname == 'cp0') {
                if (!row.lastcpname || row.lastcpname == 'cp2') {
                  i = 1
                } else {
                  i = 3
                }
              } else if (row.cpname == 'cp2') {
                i = 4
              }

              // 判断是否完赛
              if (row.speed == 0) {
                // console.log('完赛')
                // 剩余时间逻辑

                // 地图逻辑
                let marker
                if (this.p_list[row.scorename]) {
                  marker = this.p_list[row.scorename].marker
                  marker.stopMove()
                  marker.setPosition(cp0)
                } else {
                  marker = self.create_marker(row.scorename)
                }
              } else {
                if (this.p_list[row.scorename]) {
                  // 本地存在这个队伍的数据

                  // 地图逻辑
                  if (this.p_list[row.scorename].i != i) {
                    // 经过下一个cp点
                    console.log(row.scorename + '经过下一个cp点')
                    let marker = this.p_list[row.scorename].marker
                    // 停止动画
                    marker.stopMove()
                    // 开始下一段路线动画

                    new AMap.Polyline({
                      path: linex['line' + i][0].left_line,
                      showDir: true,
                      strokeColor: '#28F', //线颜色
                      // strokeOpacity: 1,     //线透明度
                      strokeWeight: 8, //线宽
                      // strokeStyle: "solid"  //线样式
                    })

                    let l = [...linex['line' + i][0].left_line].concat()

                    marker.moveAlong(l, row.speed)
                    // 配置cpname
                    this.p_list[row.scorename].cpname = row.cpname
                    this.p_list[row.scorename].i = i
                  } else {
                    // 数据无变化
                    // console.log('数据无变化')
                  }
                  p_list = this.p_list
                } else {
                  // 第一次出现

                  // 地图逻辑
                  p_list = this.p_list
                  p_list[row.scorename] = {}

                  console.log('第一次取到数据, 画点' + row.scorename)
                  p_list[row.scorename].cpname = row.cpname
                  let p_line = self.set_line({
                    speed: row.speed,
                    time: row.time,
                    systime: r.data.systime,
                    cpname: row.cpname,
                    lastcpname: row.lastcpname,
                  })
                  let marker = null

                  if (p_line.length > 1) {
                    marker = self.create_marker(row.scorename)

                    let l = [...p_line].concat()

                    marker.moveAlong(l, row.speed)
                  } else if (p_line.length == 1) {
                    if (i == 4) {
                      i = 0
                    }
                    let icon_url = mark_a

                    if (row.scorename.slice(0, 1) == 'B') {
                      icon_url = mark_b
                    }
                    marker = self.create_marker(row.scorename, linex['line' + (i + 1)][0].point)
                  }

                  p_list[row.scorename].marker = marker
                  p_list[row.scorename].i = i
                }
              }
            })
            // console.log('--------')

            this.l_time_list.sort((a, b) => {
              return a.l_time - b.l_time
            })

            this.l_time_list = this.l_time_list.slice(0, 6)

            self.$nextTick(() => {
              self.p_list = p_list
            })
          } else {
          }
          loading = false
        })
        .catch((err) => {
          loading = false
          console.error(err, 111)
        })
    },
    set_line(params) {
      let time = params.systime * 1000 - params.time
      let dis = params.speed * (time / 3600)
      let i = null

      if (params.cpname == 'cp0') {
        if (!params.lastcpname || params.lastcpname == 'cp2') {
          i = 1
        } else {
          i = 3
        }
      } else if (params.cpname == 'cp2') {
        i = 4
      } else {
        i = params.cpname.slice(-1) * 1 + 1
      }

      let item_line = linex['line' + i]

      return this.get_index(item_line, dis)
    },
    get_index(arr, dis) {
      let index
      let self = this
      let item = arr.find((item, index) => {
        return dis <= item.distance
      })

      if (item) {
        new AMap.Polyline({
          path: item.left_line,
          showDir: true,
          strokeColor: '#28F', //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 8, //线宽
          // strokeStyle: "solid"  //线样式
        })
        return item.left_line
      } else {
        return arr[arr.length - 1].left_line
      }
    },
  },
}
</script>

<style lang="less" scoped>
.map-pc {
  display: flex;
  /deep/ .amap-marker-label {
    padding: 0;
    border: none;
    .mark_a {
      border: 1px solid #c5141e;
      padding: 4px;
      background: #fff;
    }
    .mark_b {
      border: 1px solid blue;
      padding: 4px;
      background: #fff;
    }
  }
  .arrive_list {
    background-color: #c5141e;
    position: relative;
    .head {
      margin-bottom: 56px;
      img {
        width: 100%;
      }
    }
    .body {
      .item {
        padding: 15px 40px 15px 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.even {
          background: #b1111a;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
        }
        &.first {
          position: relative;
          margin-bottom: 40px;
          .info {
            margin-left: -25px;
            position: relative;
            z-index: 1;
          }
          .l-time {
            font-size: 44px;
            font-weight: bold;
          }
          .img {
            position: absolute;
            background: url(../../assets/first-bg.png) no-repeat center left/cover;
            width: 330px;
            height: 148px;
            z-index: 0;
            top: 8px;
            left: -42px;
          }
        }
        .info {
          color: #fff;
          font-size: 32px;
          .g-name {
            font-weight: bold;
            width: 226px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .l-time {
          font-size: 28px;
          color: #fff;
        }
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px 0;
      text-align: center;
      background: #fff;
      color: #a31119;
    }
  }
}
</style>
